
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzle",
      function () {
        return require("private-next-pages/puzzle/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzle"])
      });
    }
  